import fetch from '@/utils/fetch'


// 获取app版本列表
export function getVersionList(params) {
  return fetch({
    url: '/espier/versionList',
    method: 'post',
    params: params
  })
}
// 编辑版本信息
export function versionUpdate(params) {
  return fetch({
    url: '/espier/versionUpdate',
    method: 'post',
    params: params
  })
}
// 获取app信息
export function getAppVersion(params) {
  return fetch({
    url: '/appUpdate',
    method: 'get',
    params: params
  })
}

// 添加App新版本
export function addAppVersion(params) {
  return fetch({
    url: '/espier/save_apk',
    method: 'post',
    params: {
      ...params
    }
  })
}


// 帮助中心
export function getHelpList(params) {
  return fetch({
    url: '/help/lists',
    method: 'get',
    params: {
      ...params
    }
  })
}

// 帮助中心添加
export function postHelpPackage(params) {
  return fetch({
    url: '/help/package',
    method: 'post',
    params: {
      ...params
    }
  })
}

// 帮助中心删除
export function delPackage(params) {
  return fetch({
    url: '/help/del',
    method: 'get',
    params: {
      ...params
    }
  })
}


